import { createContext, useContext, useState } from "react";

const AssessmentContext = createContext();

export const AssessmentProvider = ({ children }) => {
  const [activeAssessment, setActiveAssessment] = useState(0);

  return (
    <AssessmentContext.Provider value={{ activeAssessment, setActiveAssessment }}>
      {children}
    </AssessmentContext.Provider>
  );
};

export const useAssessment = () => useContext(AssessmentContext);
